import { ElMessage } from 'element-plus'

let messageShown = false
let messageTimer = null

const showMessage = (message, type = 'warning') => {
  if (!messageShown) {
    messageShown = true
    ElMessage[type](message)
    messageTimer = setTimeout(() => {
      messageShown = false
    }, 2000)
  }
}

// 清除定时器
const clearMessageTimer = () => {
  if (messageTimer) {
    clearTimeout(messageTimer)
    messageTimer = null
  }
}

export const message = {
  success: (msg: string) => showMessage(msg, 'success'),
  warning: (msg: string) => showMessage(msg, 'warning'),
  error: (msg: string) => showMessage(msg, 'error'),
  info: (msg: string) => showMessage(msg, 'info'),
  clear: clearMessageTimer,
}

export default message
